import { connect } from 'react-redux';

import {
  registrationRequest
} from '@xanadu/ui-shared/modules/userRegistration/actions';

import {
  loginRequest,
} from '@xanadu/ui-shared/modules/userSession/actions';

import PreviousLoggedIn from '../../components/PreviousLoggedIn';

const mapDispatchToProps = {
  loginRequest,
  registrationRequest
};

function mapStateToProps(state) {
  return {
    widthSize: state.getIn(['application', 'widthSize']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviousLoggedIn);
